const SERVICE_TITLES = {
  "sales-agents-customer-service": "Sales Agents & Customer Service",
  "graphic-design": "Graphic Design",
  "3d-modeling": "3D Modeling",
  "digital-marketing": "Digital Marketing",
  "website-design-and-development": "Website Design and Development",
  "animation": "Animation",
  "twitch-packages": "Twitch Packages",
  "mobile-app-design-development": "Mobile App Design & Development",
  "illustration": "Illustration",
  "blockchain-development": "Blockchain Development",
  "smart-contracts-development": "Smart Contracts Development",
};

export const formatServiceSlug = (slug) => {
  if (!slug) return "";
  if (SERVICE_TITLES[slug]) return SERVICE_TITLES[slug];
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const pageTitle = (title) => {
  const formatted = formatServiceSlug(title) || title;
  return (document.title = formatted + " - Acsytech");
};